"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { cn } from "@/lib/utils";

interface SpecRow {
	label: string;
	value: string;
}

interface CopySpecsButtonProps {
	rows: SpecRow[];
	idleLabel: string;
	copiedLabel: string;
}

export function CopySpecsButton({ rows, idleLabel, copiedLabel }: CopySpecsButtonProps) {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		const text = rows.map((r) => `${r.label}\t${r.value}`).join("\n");
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);
			setTimeout(() => setCopied(false), 1800);
		} catch {
			// Clipboard API unavailable (e.g. insecure context) — silently no-op.
		}
	};

	return (
		<button
			type="button"
			onClick={handleCopy}
			className={cn(
				"border-border/60 flex w-full items-center justify-center gap-1.5 border-t bg-secondary px-3 py-2.5 text-xs font-semibold transition-colors hover:bg-muted",
				copied ? "text-success" : "text-primary",
			)}
			aria-live="polite"
		>
			{copied ? (
				<Check className="h-3 w-3" strokeWidth={2.5} aria-hidden />
			) : (
				<Copy className="h-3 w-3" strokeWidth={2} aria-hidden />
			)}
			{copied ? copiedLabel : idleLabel}
		</button>
	);
}
